module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_06.435370f6.png";